<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Student Import</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="4" md="4">
          <v-autocomplete rounded :items="ay_list" v-model="ay" item-text="ay" item-value="id" label="Academic Year"
            dense outlined placeholder="Select Academic Year"></v-autocomplete>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="ay != null">
        <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
          <v-file-input placeholder="CSV of student data" prepend-icon="mdi-file" label="Student Data" show-size flat
            rounded outlined dense v-model="file"></v-file-input>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
          <!-- <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/Import_Student_SCS.csv"> -->
          <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/Student_Import_Sheet.csv">
            <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
              class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
              Download import CSV format
              <v-icon right dark>mdi-cloud-download</v-icon>
            </v-btn>
          </a>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
      </v-row>
      <v-col cols="12" sm="12" md="12">
        <template v-if="load == true">
          <v-data-table dense :headers="headers" :items="statuslist" sort-by class="elevation-1 mytable"
            :search="search" :loading="output_load"></v-data-table>
        </template>
      </v-col>

      <!-- shiv new code -->
      <v-col cols="12" sm="12" md="12">
        <template v-if="load == false">
          <v-simple-table class="mytable">
            <template v-slot:default>
              <!-- <thead>
                <tr>
                  <th class="text-left">Registration_Number</th>
                  <th class="text-left">Full Name</th>
                  <th class="text-left">First Name</th>
                  <th class="text-left">Middle Name</th>
                  <th class="text-left">Last Name</th>
                  <th class="text-left">Mother First Name</th>
                  <th class="text-left">Standard</th>
                  <th class="text-left">Division</th>
                  <th class="text-left">Roll No</th>
                  <th class="text-left">DOB</th>
                  <th class="text-left">Birth Place</th>
                  <th class="text-left">Aadhar No</th>
                  <th class="text-left">Category</th>
                  <th class="text-left">Parent Email</th>
                  <th class="text-left">Contact</th>
                  <th class="text-left">Emergency_Contact_Name</th>
                  <th class="text-left">Emergency_Contact_Number</th>
                  <th class="text-left">Gender</th>
                  <th class="text-left">Blood Group</th>
                  <th class="text-left">Cast</th>
                  <th class="text-left">Secondary Parent Email</th>
                  <th class="text-left">Secondary Parent Mobile No</th>
                  <th class="text-left">Secondary Parent Full Name</th>
                  <th class="text-left">PEN No.</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>W001</td>
                  <td>Vikas Chauhan</td>
                  <td>vikas</td>
                  <td></td>
                  <td>Chauhan</td>
                  <td></td>
                  <td>UKG</td>
                  <td>A</td>
                  <td>4</td>
                  <td>12-01-2018</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Male</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="mandatory">Mandatory</td>
                  <td class="mandatory">Mandatory</td>
                  <td class="mandatory">Mandatory</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="mandatory">Mandatory</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody> -->
              <thead>
                <tr>
                  <th class="text-left">Registration_Number</th>
                  <th class="text-left">SRN</th>
                  <th class="text-left">Full Name</th>
                  <th class="text-left">Unicode Student Name</th>
                  <th class="text-left">Title</th>
                  <th class="text-left">First Name</th>
                  <th class="text-left">Middle Name</th>
                  <th class="text-left">Last Name</th>
                  <th class="text-left">Mother First Name</th>
                  <th class="text-left">Mother Name Local</th>
                  <th class="text-left">Father Name Local</th>
                  <th class="text-left">Standard</th>
                  <th class="text-left">Division</th>
                  <th class="text-left">Roll No</th>
                  <th class="text-left">DOB</th>
                  <th class="text-left">Unicode DOB</th>
                  <th class="text-left">Birth Place</th>
                  <th class="text-left">Unicode Birth Place</th>
                  <th class="text-left">Birth City</th>
                  <th class="text-left">Birth Taluka</th>
                  <th class="text-left">Unicode Birth Taluka</th>
                  <th class="text-left">Birth District</th>
                  <th class="text-left">Unicode Birth District</th>
                  <th class="text-left">Birth State</th>
                  <th class="text-left">Birth Country</th>
                  <th class="text-left">Aadhaar No</th>
                  <th class="text-left">Family Income</th>
                  <th class="text-left">Category</th>
                  <th class="text-left">Parent Email</th>
                  <th class="text-left">Contact</th>
                  <th class="text-left">Emergency_Contact_Name</th>
                  <th class="text-left">Emergency_Contact_Number</th>
                  <th class="text-left">Gender</th>
                  <th class="text-left">Mother Tongue</th>
                  <th class="text-left">Nationality</th>
                  <th class="text-left">Blood Group</th>
                  <th class="text-left">Cast</th>
                  <th class="text-left">Sub Caste</th>
                  <th class="text-left">Religion</th>
                  <th class="text-left">Secondary Parent Email</th>
                  <th class="text-left">Secondary Parent mobile no</th>
                  <th class="text-left">Secondary Parent Full Name</th>
                  <th class="text-left">GR No.</th>
                  <th class="text-left">PEN No.</th>
                  <th class="text-left">Saral No.</th>
                  <th class="text-left">Apaar Id</th>
                  <th class="text-left">Permanent Address</th>
                  <th class="text-left">Unicode Permanent Address</th>
                  <th class="text-left">Permanent Pincode</th>
                  <th class="text-left">Local Address</th>
                  <th class="text-left">Unicode Local Address</th>
                  <th class="text-left">Local City</th>
                  <th class="text-left">Local Taluka</th>
                  <th class="text-left">Local District</th>
                  <th class="text-left">Local State</th>
                  <th class="text-left">Local Country</th>
                  <th class="text-left">Local Pincode</th>
                  <th class="text-left">Quota</th>
                  <th class="text-left">house</th>
                  <th class="text-left">First Adm Class</th>
                  <th class="text-left">Since When</th>
                  <th class="text-left">Unicode Since When</th>
                  <th class="text-left">Date of Admission</th>
                  <th class="text-left">Admission Year</th>
                  <th class="text-left">Last School Attended</th>
                  <th class="text-left">Unicode Last School Attended</th>
                  <th class="text-left">School Medium</th>
                  <th class="text-left">Guardian Name</th>
                  <th class="text-left">Unicode Guardian Name</th>
                  <th class="text-left">Guardian Number</th>
                  <th class="text-left">Relation With Student</th>
                  <th class="text-left">Handicap Description</th>
                  <th class="text-left">Handicap Percentage</th>
                  <th class="text-left">Parent Occupation</th>
                  <th class="text-left">Active Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>W001</td>
                  <td>SRN00001</td>
                  <td>Vikas Chauhan</td>
                  <td>विकास चौहान</td>
                  <td></td>
                  <td>Vikas</td>
                  <td></td>
                  <td>Chauhan</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>V</td>
                  <td>A</td>
                  <td>9</td>
                  <td>12-01-2018</td>
                  <td>१२-०१-२०१८</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Male</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>0</td>
                </tr>
                <tr>
                  <td class="mandatory">Mandatory</td>
                  <td></td>
                  <td class="mandatory">Mandatory</td>
                  <td></td>
                  <td></td>
                  <td class="mandatory">Mandatory</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="mandatory">Mandatory</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-col>
      <!-- shiv code end -->
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  /*
      Defines the data used by the component
    */
  data() {
    return {
      isallowed: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      file: null,
      statuslist: "",
      load: false,
      loading3: false,
      search: "",
      ay_list: null,
      ay: null,
      // headers: [
      //   { text: "Sr.NO", value: "serial_number" },
      //   { text: "Status", value: "status" },
      //   { text: "Login Id", value: "loginid" },
      //   { text: "Reason", value: "reason" },
      //   { text: "Registration Number", value: "registration_number" },
      //   { text: "Full Name", value: "fullname" },
      //   { text: "First Name", value: "firstname" },
      //   { text: "Middle Name", value: "middlename" },
      //   { text: "Last Name", value: "lastname" },
      //   { text: "Mother First Name", value: "mother_first_name" },
      //   { text: "Standard", value: "standard" },
      //   { text: "Division", value: "division" },
      //   { text: "Roll No", value: "rollnumber" },
      //   { text: "DOB", value: "birthdate" },
      //   { text: "Birth Place", value: "birth_place" },
      //   { text: "Aadhar No", value: "aadhar_no" },
      //   { text: "Category", value: "category" },
      //   { text: "Parent Email", value: "parentemail" },
      //   { text: "Contact", value: "contactnumber" },
      //   { text: "Emergency Contact Name", value: "emergency_contact_name" },
      //   { text: "Emergency Contact Number", value: "emergency_contact_number" },
      //   { text: "Gender", value: "gender" },
      //   { text: "Blood Group", value: "bloodgroup" },
      //   { text: "Cast", value: "cast" },
      //   { text: "Secondary Parent Email", value: "secondaryparentemail" },
      //   { text: "Secondary Parent Mobile No", value: "secondary_parent_mobile_no" },
      //   { text: "Secondary Parent Full Name", value: "secondary_parent_fullname" },
      //   { text: "PEN No.", value: "pen_no" }
      // ],
      headers: [
        { text: "Sr.NO", value: "serial_number" },
        { text: "Status", value: "status" },
        { text: "Login Id", value: "loginid" },
        { text: "Reason", value: "reason" },
        { text: "Registration Number", value: "registration_number" },
        { text: "SRN", value: "srn" },
        { text: "Title", value: "title" },
        { text: "Full Name", value: "fullname" },
        { text: "Unicode Student Name", value: "unicode_student_name" },
        { text: "First Name", value: "firstname" },
        { text: "Middle Name", value: "middlename" },
        { text: "Last Name", value: "lastname" },
        { text: "Mother First Name", value: "mother_first_name" },
        { text: "Mother Name Local Language", value: "mother_name_local_lang" },
        { text: "Father name Local Language", value: "father_name_local_lang" },
        { text: "Standard", value: "standard" },
        { text: "Division", value: "division" },
        { text: "Roll No", value: "rollnumber" },
        { text: "GR No", value: "gr_no" },
        { text: "DOB", value: "birthdate" },
        { text: "Unicode DOB", value: "unicode_date_of_birth" },
        { text: "Birth Place", value: "birth_place" },
        { text: "Birth District", value: "birth_district" },
        { text: "Birth Taluka", value: "birth_taluka" },
        { text: "Birth City", value: "birthcity" },
        { text: "Birth State", value: "birth_state" },
        { text: "Birth Country", value: "birth_country" },
        { text: "Unicode Birth Place", value: "unicode_birth_place" },
        { text: "Unicode Birth District", value: "unicode_birth_district" },
        { text: "Unicode Birth Taluka", value: "unicode_birth_taluka" },
        { text: "Family Income", value: "family_income" },
        { text: "Aadhaar No", value: "aadhar_no" },
        { text: "Apaar Id", value: "apaar_id" },
        { text: "Saral id", value: "saral_id" },
        { text: "PEN No.", value: "pen_no" },
        { text: "Gender", value: "gender" },
        { text: "Blood Group", value: "bloodgroup" },
        { text: "Cast", value: "cast" },
        { text: "Category", value: "category" },
        { text: "Mother Tongue", value: "mothertoungue" },
        { text: "Parent Email", value: "parentemail" },
        { text: "Contact", value: "contactnumber" },
        { text: "Guardian Name", value: "guardian_name" },
        { text: "Unicode Guardian Name", value: "unicode_guardian_name" },
        { text: "Guardian Contact", value: "guardian_contact" },
        { text: "Guardia Relation", value: "guardian_relation" },
        { text: "Admission Date", value: "admission_date" },
        { text: "Since When", value: "physical_date" },
        { text: "Admitted Standard", value: "admittedstandard" },
        { text: "Unicode Since When", value: "unicode_physical_date" },
        { text: "Previous School", value: "previous_school_name" },
        { text: "Unicode Previous School", value: "unicode_previous_school_name" },
        { text: "Permanent Address", value: "permanentaddress" },
        { text: "Permanent Pincode", value: "permanentpincode" },
        { text: "Unicode Permanent Address", value: "permanentunicodeaddress" },
        { text: "Local Address", value: "localaddress" },
        { text: "Unicode Local Address", value: "localunicodeaddress" },
        { text: "Local City", value: "localcity" },
        { text: "Local Taluka", value: "localtaluka" },
        { text: "Local District", value: "localdistrict" },
        { text: "Local State", value: "localstate" },
        { text: "Local Country", value: "localcountry" },
        { text: "Local Pincode", value: "localpincode" },
        { text: "Emergency Contact Name", value: "emergency_contact_name" },
        { text: "Emergency Contact Number", value: "emergency_contact_number" },
        { text: "Physically Handicapped Detail", value: "physicallyhandicapped_details" },
        { text: "Disability Percentage", value: "disability_percentage" },
        { text: "Secondary Parent Email", value: "secondaryparentemail" },
        { text: "Secondary Parent Mobile No", value: "secondary_parent_mobile_no" },
        { text: "Secondary Parent Full Name", value: "secondary_parent_fullname" },
        { text: "Active Status", value: "active_status" },

      ],
      output_load: false,
    };
  },
  mounted() {
    axios
      .post("/InstallmentStructureDetails/importLearnerSelectionHome")
      .then((res) => {
        this.ay_list = res.data.ay_list;
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      })
      .finally(() => { });
  },
  methods: {
    submitFile() {
      if (this.file == null) {
        alert("Please select the file!");
      } else {
        this.output_load = true;
        let formData = new FormData();
        //console.log(this.file.size)
        formData.append("file", this.file);
        formData.append("ay", this.ay);


        //console.log(formData)
        axios
          .post("RoleManagement/importStudentDes", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.flag == "YES") {
              this.statuslist = res.data.statuslist;
              this.isallowed = res.data.isallowed
              this.load = true;
              //this.getsubjectoffering()
              // Object.assign(this.courselist[this.editedIndex], this.editedItem);
            } else if (res.data.flag == "No") {
              this.showSnackbar("red", res.data.snackbar);
              this.isallowed = res.data.isallowed
              this.overlay = false;
            }
          })
          .catch(function () {
            console.log("FAILURE!!");
          })
          .finally(() => {
            this.output_load = false;
          });
        //     }
      }
    }, //end of the fuction
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    /*
        Handles a change on the file upload
      */
  },
};
</script>
<style scoped>
.downbtn {
  float: right;
}

/* new css */
table,
th {
  padding: 10px;
  border: 1px solid black;
  border-collapse: collapse;
  background: #0f2027;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}

.mandatory {
  color: red;
}
</style>
